const FilterItem = ({ name, hideName = false, children }) => {
  return (
    <div className={`filter-item ${name.replace(" ", "-").toLowerCase()}`}>
      {!hideName && <strong>{name}</strong>}
      {children}
    </div>
  );
};

export default FilterItem;
